module.exports = __webpack_public_path__ + "02_hair_gold.a01adfde.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/02_hair_gold.png
// module id = TeGc
// module chunks = 0